import React, { useEffect, useRef, useState } from 'react'
import { CloseButton, Footer } from '../../Modals/AddToCartModal'
import { revertQuantity } from '../../HelperFunctions'

export const OnlyContractModal = ({ updateCart, setUpdateCart, setItems }) => {
    if (updateCart?.RestrictionTypes?.includes('OnlyContractPrice')) {
        const [restrictAdminsModel, setRestrictAdminsModel] = useState(null);
        const plural = useRef(false);
        useEffect(() => {
            $.getJSON('/ShoppingCart/GetRestrictAdmins/OnlySupplyList', function (response) {
                plural.current = $('.restricted-item').length > 1;
                setRestrictAdminsModel(response);
            })
            setItems([...updateCart.ItemList])
        }, []);

        return (<>
            <div className="tw-flex tw-relative tw-flex-col sm:tw-w-[511px] tw-bg-white">
                <div className="tk-trade-gothic-next tw-text-mine-shaft-950 tw-flex tw-flex-col ">
                    <CloseButton updateCart={updateCart} setUpdateCart={setUpdateCart} />
                    <div className="sm:tw-mx-[24px] tw-p-[1rem] tw-pb-[0.5rem]" style={{ borderBottom: "1.5px solid #282828" }} >
                        <h5 className="modal-title tw-flex tw-gap-[6px] tw-font-bold tw-text-[24px]">
                            {'Contract Pricing Restriction' + (window.innerWidth >= 576 ? ' in Effect' : '')}
                        </h5>
                    </div>
                    <div className="tw-px-[20px] sm:tw-pl-[42px] sm:tw-pr-[2rem] tw-pt-[1rem] tw-overflow-auto tw-max-h-[360px]">
                        <div className="tw-mb-[10px]">
                            {`The following ${plural.current ? 'items' : 'item'} ${plural.current ? 'are' : 'is'} not in your contract pricing list. 
                        Therefore, ${plural.current ? 'they' : 'it'} could not be added to your cart. Please contact your administrator.`}
                        </div>
                        <div className="tw-mb-[4px]">
                            {plural ? 'Items:' : 'Item:'}
                        </div>
                        {updateCart.ItemList.map((item, i) => {
                            return item.UoMPrices.map((uom, j) => {
                                if (uom.MessageCode === 'OnlyContractPrice') {
                                    useEffect(() => revertQuantity(updateCart, i, j), []);
                                    return (<div className="restricted-item tw-ml-[6px] tw-leading-[22px] tw-mb-[3px]">{uom.ItemID}, {uom.UoM}</div>)
                                }
                            })
                        })}
                        {(!!restrictAdminsModel && !!restrictAdminsModel.RestrictAdmins.length) &&
                            <table className="tw-w-full tw-mt-[18px] lg:tw-mt-[25px]">
                                <colgroup>
                                    <col span="1" className="tw-w-[33%]" />
                                    <col span="1" className="tw-w-[33%]" />
                                    <col span="1" className="tw-w-[33%]" />
                                </colgroup>
                                <tr className="tw-text-tamarillo-700 tw-font-bold tw-leading-[30px] tw-text-center"
                                    style={{ borderTop: "1px solid #A2A2A2", borderBottom: "1px solid #A2A2A2" }}><td>Name</td><td>Email</td><td>Phone</td>
                                </tr>
                                {restrictAdminsModel.RestrictAdmins.map((admin, i) =>
                                    <tr className="tw-text-center">
                                        <td className={"tw-py-[6px] " + (i === 0 ? "tw-pt-[10px]" : "")}>
                                            {admin.FirstName + ' ' + admin.LastName}
                                        </td>
                                        <td>{admin.Email}</td>
                                        <td>{admin.Phone}</td>
                                    </tr>
                                )}
                            </table>
                        }
                    </div>
                    <Footer updateCart={updateCart} setUpdateCart={setUpdateCart} />
                </div>
            </div>
        </>)
    }
}